import {
  appLogin,
  appRegisterUser,
  appSocialLogin,
  appLogout,
  appVerifyOTPAndLogin,
  // syncRegisterUserData, // API Security - Step 4 (23-10-2026): US site signup sync stopped
} from "../../services/AuthServices";
import { TOKEN_KEY, USER_KEY } from "../../utils/Constant";

import {
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  USER_LOADED,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  ADD_CART_COUNT,
  LOGOUT_SUCCESS,
  CLEAR_CART_COUNT,
} from "../actions/types";
import { returnErrors } from "./errorActions";
import {commonPageEventsFB, initPixel} from "../../utils/PixelEvents/FacebookEvents";
import {GoogleCommonEvents} from "../../utils/PixelEvents/GoogleEvents";

// Check token & load user
export const loadUser = () => (dispatch, getState) => {
  // User loading

  dispatch({ type: USER_LOADING });

  const token = localStorage.getItem(TOKEN_KEY);

  let user = localStorage.getItem(USER_KEY);

  user = user ? JSON.parse(user) : null;

  // const isAuthenticated = getState().auth.isAuthenticated;

  if (!token || !user) {
    return dispatch({
      type: AUTH_ERROR,
    });
  }

  return dispatch({
    type: USER_LOADED,
    payload: { ...user, token: token },
  });
};

// Login User
export const login = ({ email, password }) => {
  return async (dispatch) => {
    // call login api and get response
    return appLogin({ email, password })
      .then((response) => {
        response = JSON.parse(response.data);

        let loginUser = response?.login_user;
        if (loginUser?.status === "success") {
          document.body.setAttribute('style',''); 
          loginUser = { ...loginUser, token: response?.SID };
          // Re-initialize pixel with user data for Advanced Matching / EMQ
          try {
            initPixel(loginUser);
          } catch (e) {
            console.log(e.message);
          }
          // handling error in try catch block
          try {
            commonPageEventsFB('Account Login');
          } catch (e) {
            console.log(e.message);
          }
          // handling error in try catch block
          try {
            GoogleCommonEvents('account login');
          } catch (e) {
            console.log(e.message);
          }
          dispatch({
            type: ADD_CART_COUNT,
            payload: {cartCount: loginUser?.cart_count || 0},
          });

          dispatch({
            type: LOGIN_SUCCESS,
            payload: loginUser,
          });
          return Promise.resolve(true);
        } else {
          dispatch(returnErrors(loginUser.message, null, LOGIN_FAIL));
          dispatch({
            type: LOGIN_FAIL,
          });
          return Promise.resolve(false);
        }
      })
      .catch((err) => {
        dispatch(
          returnErrors(err.response.data, err.response.status, LOGIN_FAIL)
        );
        dispatch({
          type: AUTH_ERROR,
        });
        return Promise.reject();
      });
  };
};

// Social Login User
export const socialLogin = (loginData, socialType) => {
  return async (dispatch) => {
    // call login api and get response
    return appSocialLogin({ login: JSON.stringify(loginData) })
      .then((response) => {
        response = JSON.parse(response.data);

        let loginUser = response?.login_user;
        if (loginUser?.status === "success") {
          document.body.setAttribute('style',''); 
          loginUser = {
            ...loginUser,
            token: response?.SID,
            socialLoginType: socialType,
          };
          // Re-initialize pixel with user data for Advanced Matching / EMQ
          try {
            initPixel(loginUser);
          } catch (e) {
            console.log(e.message);
          }
          // handling error in try catch block
          try {
            commonPageEventsFB('Account Login');
          } catch (e) {
            console.log(e.message);
          }
          // handling error in try catch block
          try { 
            GoogleCommonEvents('account login');
          } catch (e) {
            console.log(e.message);
          }
          dispatch({
            type: ADD_CART_COUNT,
            payload: {cartCount: loginUser?.cart_count || 0},
          });

          dispatch({
            type: LOGIN_SUCCESS,
            payload: loginUser,
          });
          return Promise.resolve(true);
        } else {
          dispatch(returnErrors(loginUser?.message || "Social login could not be verified. Please try again.", null, LOGIN_FAIL));
          // API Security - Step 4 (23-10-2026): LOGIN_FAIL action not dispatched here because it removes the
          // session id (SID) from localStorage and the guest cart is lost when the social token is rejected.
          return Promise.resolve(false);
        }
      })
      .catch((err) => {
        dispatch(
          returnErrors(err.response.data, err.response.status, LOGIN_FAIL)
        );
        dispatch({
          type: AUTH_ERROR,
        });
        return Promise.reject();
      });
  };
};

/**
 * BOC
 * API Security - Step 4 OTP login / signup UI
 * date 23-10-2026
 * use_of_code: OTP login and OTP signup. On a failure (wrong / expired OTP) the LOGIN_FAIL / REGISTER_FAIL actions
 * are NOT dispatched, because they remove the session id (SID) from localStorage and the OTP is bound to that
 * session on the server. The caller shows the returned message.
 */
const onAuthSuccess = (dispatch, user, actionType, fbEvent, googleEvent) => {
  document.body.setAttribute('style','');
  // Re-initialize pixel with user data for Advanced Matching / EMQ
  try {
    initPixel(user);
  } catch (e) {
    console.log(e.message);
  }
  try {
    commonPageEventsFB(fbEvent);
  } catch (e) {
    console.log(e.message);
  }
  try {
    GoogleCommonEvents(googleEvent);
  } catch (e) {
    console.log(e.message);
  }
  if (actionType === LOGIN_SUCCESS) {
    dispatch({
      type: ADD_CART_COUNT,
      payload: {cartCount: user?.cart_count || 0},
    });
  }
  dispatch({
    type: actionType,
    payload: user,
  });
};

// Login with OTP: data = { login_id, otp }
export const otpLogin = (data) => {
  return async (dispatch) => {
    try {
      const response = JSON.parse((await appVerifyOTPAndLogin(data)).data);
      const loginUser = response?.login_user;
      if (loginUser?.status === "success") {
        onAuthSuccess(dispatch, { ...loginUser, token: response?.SID }, LOGIN_SUCCESS, 'Account Login', 'account login');
        return { status: "success" };
      }
      return { status: "failure", error_code: loginUser?.error_code || "", message: loginUser?.message || "Something went wrong. Please try again." };
    } catch (e) {
      return { status: "failure", message: "Something went wrong. Please try again." };
    }
  };
};

// Signup with OTP: data = signup data with is_validate 0 and otp (no password)
export const registerWithOtp = (data) => {
  return async (dispatch) => {
    try {
      const response = JSON.parse((await appRegisterUser(data)).data);
      const signupUser = response?.signup_user;
      if (signupUser?.status === "success") {
        onAuthSuccess(dispatch, { ...signupUser, token: response?.SID }, REGISTER_SUCCESS, 'Account Create', 'account create');
        return { status: "success" };
      }
      return { status: "failure", error_code: signupUser?.error_code || "", message: signupUser?.message || "Something went wrong. Please try again." };
    } catch (e) {
      return { status: "failure", message: "Something went wrong. Please try again." };
    }
  };
};
/**
 * EOC
 */

// Register User
export const register = (data) => {
  return async (dispatch) => {
    // call login api and get response
    return appRegisterUser(data)
      .then((response) => {
        response = JSON.parse(response.data);

        let signupUser = response?.signup_user;
        if (signupUser?.status === "success") {
          // API Security - Step 4 (23-10-2026): US site signup sync stopped
          // syncRegisterUserData(data);
          document.body.setAttribute('style',''); 
          signupUser = { ...signupUser, token: response?.SID };
          // Re-initialize pixel with user data for Advanced Matching / EMQ
          try {
            initPixel(signupUser);
          } catch (e) {
            console.log(e.message);
          }
          // handling error in try catch block
          try {
            commonPageEventsFB('Account Create');
          } catch (e) {
            console.log(e.message);
          }
          // handling error in try catch block
          try {
            GoogleCommonEvents('account create');
          } catch (e) {
            console.log(e.message);
          }
          dispatch({
            type: REGISTER_SUCCESS,
            payload: signupUser,
          });
          return Promise.resolve(true);
        } else {
          dispatch(returnErrors(signupUser.message, null, REGISTER_FAIL));
          dispatch({
            type: REGISTER_FAIL,
          });

          return Promise.resolve(false);
        }
      })
      .catch((err) => {
        dispatch(
          returnErrors(err.response.data, err.response.status, REGISTER_FAIL)
        );
        dispatch({
          type: AUTH_ERROR,
        });
        return Promise.reject();
      });
  };
};

// logout
// export const logout = () => (dispatch) => {
  export const logout = () => {  

  return async (dispatch) => {
    dispatch({
      type: CLEAR_CART_COUNT,
    });
    dispatch({
      type: LOGOUT_SUCCESS,
    });
    return appLogout()
      .then((response) => {
        response = JSON.parse(response.data);
        if (response?.status === "success") {          
          return Promise.resolve(true);
        }
      })
      .catch((err) => {        
        dispatch({
          type: AUTH_ERROR,
        });
        return Promise.reject();
      });
  };
  // dispatch({
  //   type: CLEAR_CART_COUNT,
  // });
  // return dispatch({
  //   type: LOGOUT_SUCCESS,
  // });
};

export const addWishlistCount = (loginUser) => {
  return {
    type: LOGIN_SUCCESS,
    payload: loginUser,
  };
};
